import React, { useState } from "react";

import { TRIGGER_TYPE_OPTIONS, TriggerSettings, TriggerType } from "api/model/alerts/alert-types";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";
import TriggerSettingsEditor from "./TriggerSettingsEditor";
import { TriggerFormItem } from "./types";
import { getDefaultSettingsForType } from "./utils";

type NewTriggerFormProps = {
  onSave: (trigger: TriggerFormItem["newTrigger"]) => void;
  onCancel: () => void;
};

const NewTriggerForm: React.FC<NewTriggerFormProps> = ({ onSave, onCancel }) => {
  const [name, setName] = useState("");
  const [triggerType, setTriggerType] = useState<TriggerType>("DATASET_VALUE_CHANGED");
  const [settings, setSettings] = useState<TriggerSettings>(
    getDefaultSettingsForType("DATASET_VALUE_CHANGED")
  );
  const [retentionTime, setRetentionTime] = useState(300);

  const handleTypeChange = (newType: TriggerType) => {
    setTriggerType(newType);
    setSettings(getDefaultSettingsForType(newType));
  };

  const updateSettings = (key: string, value: unknown) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name, triggerType, settings, retentionTime });
  };

  return (
    <div className="border-1 border-primary border-round p-3 surface-ground">
      <div className="grid">
        <div className="col-12">
          <label className="block mb-1">{T("word.name")} *</label>
          <InputText
            value={name}
            onChange={e => setName(e.target.value)}
            className="w-full"
            placeholder={T("word.name")}
          />
        </div>

        <div className="col-6">
          <label className="block mb-1">{T("word.type")}</label>
          <Dropdown
            value={triggerType}
            options={TRIGGER_TYPE_OPTIONS}
            onChange={e => handleTypeChange(e.value)}
            className="w-full"
          />
        </div>

        <div className="col-6">
          <label className="block mb-1">{T("word.retention-time")} (s)</label>
          <InputNumber
            value={retentionTime}
            onValueChange={e => setRetentionTime(e.value ?? 300)}
            min={1}
            className="w-full"
          />
        </div>

        <div className="col-12">
          <TriggerSettingsEditor
            type={triggerType}
            settings={settings as Record<string, unknown>}
            onUpdateSettings={updateSettings}
          />
        </div>
      </div>

      <div className="flex justify-content-end gap-2 mt-3">
        <Button
          type="button"
          label={T("word.cancel")}
          onClick={onCancel}
          className="p-button-sm p-button-secondary p-button-outlined"
        />
        <Button
          type="button"
          label={T("action.add")}
          onClick={handleSave}
          className="p-button-sm"
          disabled={!name.trim()}
        />
      </div>
    </div>
  );
};

export default NewTriggerForm;
